import { Modal, Result, useToast } from '@bfe/moly';
import { useState } from 'react';

import SecurityComponent from '@/components/SecurityComponent/new';
import { useI18nContext } from '@/i18n/I18n';
import { deleteMainDeviceBind } from '@/services/primaryDevice';
import { SCENES } from '@/utils/securityComponent';
import { mainDeviceDisableFail } from '@/utils/trace-list/main-device';

const DisableMainDevice = ({
  visibleDisableModal,
  onSuccess,
  onClose,
}: {
  visibleDisableModal: boolean;
  onClose: () => void;
  onSuccess: () => void;
}) => {
  const [$t] = useI18nContext();
  const { toast, EToastType } = useToast();

  const [showSecurityComponent, setShowSecurityComponent] = useState(false);

  const onOk = () => {
    setShowSecurityComponent(true);
  };

  const onSecuritySuccess = (risk_token: string) => {
    deleteMainDeviceBind({ risk_token })
      .then((res) => {
        if (res?.result?.result) {
          toast({
            iconType: EToastType.SUCCESS,
            title: $t('SuccessfullyUnlinked'),
          });
          onSuccess();
        }
      })
      .catch((error: any) => {
        toast({
          iconType: EToastType.SUCCESS,
          title: error?.ret_msg || $t('SuccessfullyUnlinked'),
        });
        mainDeviceDisableFail(error);
      })
      .finally(() => {
        onClose();
      });
  };

  return (
    <>
      {/* 解绑弹窗 */}
      <Modal
        title={false}
        onOk={onOk}
        onCancel={onClose}
        open={visibleDisableModal}
        size="small"
        cancelText={$t('Cancel')}
        okText={$t('Disable')}
        wrapClassName="unbind-confirm-modal"
        modal={false}
      >
        <Result
          title={$t('confirmRemoveMainDevice')}
          subTitle={false}
          extra={
            <div className="explain-list">
              <div className="explain-list-title">{$t('unbind2faNote')}</div>
              <ul className="explain-list-content">
                <li>{$t('unbindMainDeviceTip')}</li>
              </ul>
            </div>
          }
          size="medium"
          status="warning"
        ></Result>
      </Modal>

      {/* 安全组件 */}
      <SecurityComponent
        show={showSecurityComponent}
        scene={SCENES.UNBIND_PRIMARY_DEVICE}
        onSuccess={(risk_token) => {
          setShowSecurityComponent(false);
          onSecuritySuccess(risk_token);
        }}
        onClose={(riskTokenType, riskToken) => {
          // 如果安全组件下发了引导项，并且用户关闭了引导弹窗，也认为是校验成功
          if (riskTokenType === 'guide' && riskToken) {
            onSecuritySuccess(riskToken);
          }
          setShowSecurityComponent(false);
        }}
      />
    </>
  );
};

export default DisableMainDevice;
